module.exports = __webpack_public_path__ + "48773f5cc951a16bfaa8d94bbd2a0f4d.svg";